<template>
    <div class="hitchRideDriverAuditRule">
        <custom-city-tree ref="customCityTree" @city-selected="handleCitySelect"
            url="/api/v1/manage/driverAndVehicle/audit/config">
            <template>
                <el-button style="width: 100%;" @click="showModal" size="small">添加城市认证规则</el-button>
            </template>
        </custom-city-tree>

        <div class="hitchRideDriverAuditRule-content">
            <driverAuditForm :rowData="{ ...selectCity }" @refresh="refresh"></driverAuditForm>
        </div>

        <el-dialog title="车主认证规则配置" :visible.sync="visibleDialog" :before-close="handClose" width="500px"
            v-if="visibleDialog">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
                <el-form-item label="规则适用城市" prop="cityCode">
                    <el-select v-model="ruleForm.cityCode" placeholder="请选择" filterable>
                        <el-option v-for="item in city" :key="item.adcode" :label="item.name"
                            :value="item.citycode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="车主年龄范围" prop="age" class="ageFormItem">
                    <el-form-item prop="driverMinAge" style="display: inline-block; width: 138px">
                        <el-input v-model="ruleForm.driverMinAge" :maxlength="3"
                            @input="inputNumber($event, 'driverMinAge')">
                            <template slot="append">岁</template>
                        </el-input>
                    </el-form-item>
                    <span> 至 </span>
                    <el-form-item prop="driverMaxAge" style="display: inline-block; width: 139px">
                        <el-input v-model="ruleForm.driverMaxAge" :maxlength="3"
                            @input="inputNumber($event, 'driverMaxAge')">
                            <template slot="append">岁</template>
                        </el-input>
                    </el-form-item>
                </el-form-item>
                <el-form-item label="车主最低驾龄" prop="drivingAge">
                    <el-input v-model="ruleForm.drivingAge" :maxlength="3" @input="inputNumber($event, 'drivingAge')">
                        <template slot="append">年</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="车主准驾车型" prop="driverClass">
                    <el-checkbox :indeterminate="driverClassChecked" v-model="driverClassAll"
                        @change="driverClassCheckAllChange">全部
                    </el-checkbox>
                    <el-checkbox-group @change="driverClassCheck" v-model="ruleForm.driverClass">
                        <el-checkbox v-for="item in $const.DRIVERSHORTTYPE" :key="item.value" :label="item.value">{{
                            item.label
                            }}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="车辆使用性质" prop="useCharacter">
                    <el-checkbox :indeterminate="useCharacterChecked" v-model="useCharacterAll"
                        @change="useCharacterCheckAllChange">全部
                    </el-checkbox>
                    <el-checkbox-group @change="useCharacterCheck" v-model="ruleForm.useCharacter">
                        <el-checkbox v-for="item in $const.USENATURE" :key="item.value" :label="item.value">{{
                            item.label
                            }}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item label="车辆最大年限" prop="vehicleMaxLife">
                    <el-input v-model="ruleForm.vehicleMaxLife" :maxlength="3"
                        @input="inputNumber($event, 'vehicleMaxLife')">
                        <template slot="append">年</template>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handClose">取 消</el-button>
                <el-button type="primary" @click="sure" :loading="submitLoading">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import CustomCityTree from './components/CustomCityTree.vue';
import driverAuditForm from "./components/driverAuditForm.vue";
import { cityCodeJson } from "@/assets/js/city";
export default {
    components: { CustomCityTree, driverAuditForm },
    data() {
        return {
            selectCity: {},
            cityList: cityCodeJson,
            props: {
                label: "name",
                value: "citycode",
                children: "districts",
            },
            visibleDialog: false,
            driverClassAll: true, // 车主准驾车型全选
            driverClassChecked: false,
            useCharacterAll: false, // 车主使用性质全选
            useCharacterChecked: true,
            submitLoading: false,
            ruleForm: {
                age: 1,
                cityCode: "",
                driverMinAge: 20,
                driverMaxAge: 60,
                drivingAge: 1,
                driverClass: ["C1", "C2", "B1", "B2", "A1", "A2", "A3"],
                useCharacter: ["非营运", "营转非", "出租转非", "预约出租转非"],
                vehicleMaxLife: 10,
            },
            rules: {
                cityCode: [
                    { required: true, message: "请选择城市", trigger: "change" },
                ],
                age: [{ required: true, trigger: "blur" }],
                driverMinAge: [
                    { required: true, message: "请输入车主最小年龄", trigger: "blur" },
                    { validator: this.validateDriverMinAge, trigger: "blur" },
                ],
                driverMaxAge: [
                    { required: true, message: "请输入车主最大年龄", trigger: "blur" },
                    { validator: this.validateDriverMaxAge, trigger: "blur" },
                ],
                driverClass: [
                    { required: true, message: "请选择准驾车型", trigger: "change" },
                ],
                useCharacter: [
                    { required: true, message: "请选择车辆使用性质", trigger: "change" },
                ],
                drivingAge: [
                    { required: true, message: "请输入车主最低驾龄", trigger: "blur" },
                ],
                vehicleMaxLife: [
                    { required: true, message: "请输入车辆最大年限", trigger: "blur" },
                ],
            },
        };
    },
    computed: {
        driverClassType() {
            return this.$const.DRIVERSHORTTYPE.map((item) => item.value);
        },
        useCharacterType() {
            return this.$const.USENATURE.map((item) => item.value);
        },
        city() {
            let arr = []
            this.cityList.forEach((pre) => {
                if (pre.districts) {
                    pre.districts.forEach((item) => {
                        arr.push(item)
                    })
                }
            })
            return arr
        },
    },
    created() {

    },
    methods: {
        validateDriverMinAge(rule, value, callback) {
            if (value === "") {
                callback(new Error("请输入车主最小年龄"));
            } else if (value >= this.ruleForm.driverMaxAge) {
                callback(new Error("请小于最大年龄!"));
            } else {
                callback();
            }
        },
        validateDriverMaxAge(rule, value, callback) {
            if (value === "") {
                callback(new Error("请输入车主最大年龄"));
            } else if (value <= this.ruleForm.driverMinAge) {
                callback(new Error("请大于最小年龄!"));
            } else {
                callback();
            }
        },
        inputNumber(e, prop) {
            this.ruleForm[prop] = e.replace(/[^\d]/g, "");
            if (this.ruleForm[prop] !== '' && this.ruleForm[prop] < 1) {
                this.ruleForm[prop] = 1
            }
        },
        driverClassCheckAllChange(val) {
            console.log('val::: ', val);
            this.ruleForm.driverClass = val ? this.driverClassType : [];
            this.driverClassChecked = false;
        },
        useCharacterCheckAllChange(val) {
            console.log('val::: ', val);
            this.ruleForm.useCharacter = val ? this.useCharacterType : [];
            this.useCharacterChecked = false;
        },
        driverClassCheck(value) {
            console.log('value::: ', value);
            let checkedCount = value.length;
            this.driverClassAll = checkedCount === this.driverClassType.length;
            this.driverClassChecked =
                checkedCount > 0 && checkedCount < this.driverClassType.length;
        },
        useCharacterCheck(value) {
            console.log('value::: ', value);
            let checkedCount = value.length;
            this.useCharacterAll = checkedCount === this.useCharacterType.length;
            this.useCharacterChecked =
                checkedCount > 0 && checkedCount < this.useCharacterType.length;
        },
        async showModal() {
            this.visibleDialog = true;
        },
        sure() {
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    this.submitLoading = true;
                    let params = this.$utils.deepCopyFn(this.ruleForm);
                    params.driverClass = params.driverClass.join(",");
                    params.useCharacter = params.useCharacter.join(",");
                    params.cityName = this.city.find(
                        (item) => item.citycode === params.cityCode
                    ).name;
                    params.provinceName = this.$utils.getCityName(this.cityList, params.cityCode, 'province')
                    delete params.age;
                    const url = "/api/v1/manage/driverAndVehicle/audit/config";
                    const { code } = await this.$axios.post(url, params);
                    if (code === 1) {
                        this.$message.success("保存成功");
                        this.handClose();
                    }
                    this.submitLoading = false;
                }
            });
        },
        handClose() {
            this.visibleDialog = false;
            this.ruleForm = {
                age: 1,
                cityCode: "",
                cityName: "",
                driverMinAge: 20,
                driverMaxAge: 60,
                drivingAge: 1,
                driverClass: ["C1", "C2", "B1", "B2", "A1", "A2", "A3"],
                useCharacter: ["非营运", "营转非", "出租转非", "预约出租转非"],
                vehicleMaxLife: 10,
            };
            this.refresh()
        },
        handleCitySelect(node) {
            this.selectCity = node;
        },
        refresh() {
            this.$refs.customCityTree.getCityData(true);
        }
    }
};
</script>

<style lang="less" scoped>
.hitchRideDriverAuditRule {
    display: flex;
    gap: 20px;

    &-content {
        padding: 20px 24px;
        flex: 1;
        max-height: calc(100vh - 240px);
        overflow-y: auto;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    }

    // 弹窗样式
    /deep/ .el-dialog {
        border-radius: 8px;
        
        .el-dialog__header {
            padding: 16px 20px;
            border-bottom: 1px solid #ebeef5;
            
            .el-dialog__title {
                font-size: 16px;
                font-weight: 600;
                color: #303133;
            }
        }
        
        .el-dialog__body {
            padding: 20px;
        }
        
        .el-form-item__label {
            font-weight: 500;
            color: #606266;
        }
        
        .el-input__inner {
            border-radius: 6px;
        }
        
        .el-select {
            width: 100%;
        }
        
        .el-checkbox-group {
            display: flex;
            flex-wrap: wrap;
            gap: 8px 16px;
            margin-top: 8px;
        }
        
        .dialog-footer {
            text-align: right;
            
            .el-button {
                min-width: 80px;
                border-radius: 6px;
            }
        }
    }

    .ageFormItem {
        /deep/ .el-form-item__content {
            display: flex;
            align-items: center;
            gap: 8px;
        }
    }
}
</style>